import { C as d, a as m } from "../TryTemplateButton-Dy_haQdB.mjs";
const y = () => {
  const l = async ({ templateSlug: e, shouldUseTemplateAPIExecute: u, url: p = window.location.href, apiHostName: h }) => {
    var a, s;
    try {
      const t = await fetch(`${h || ""}/api/templates/execute`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          templateSlug: e,
          url: p,
          shouldUseTemplateAPIExecute: u
        }),
        credentials: "include"
      }), o = await t.json();
      if (!t.ok) {
        const c = t.status, r = o.errors ? o.errors[0] : (s = (a = o.responseBody) === null || a === void 0 ? void 0 : a.errors) === null || s === void 0 ? void 0 : s[0];
        throw r?.code === "service:unknown" ? new Error(`Failed to execute (status: ${c}) ${r.error}`) : r || new Error(`HTTP ${c}`);
      }
      const n = new URL(o.redirectTo, window.location.origin);
      n.searchParams.set(d, m), window.location.href = n.href;
    } catch (t) {
      throw console.error("Template execution error:", t), t;
    }
  }, i = "Something went wrong while trying to use this template.";
  return { executeTemplate: l, formatExecutionError: (e) => {
    switch (e.code) {
      case "tables:limits:too_many_tables":
      case "limits:too_many_tables":
        return "You have reached the limit of Tables for your plan. Please upgrade your plan to create more.";
      case "limits:projects":
      case "interfaces:limits:projects":
        return "You have reached the limit of Interfaces for your plan. Please upgrade your plan to create more.";
      case "limits:chatbots":
      case "chatbots:limits:chatbots":
        return "You have reached the limit of Chatbots for your plan. Please upgrade your plan to create more.";
      case "upstream-error":
        return e.title === "GulliverApiError" && (e.status === "426" || e.status === "402") ? "This template contains Zap(s) that includes features (steps, paths, premium apps) not covered by your plan. Please upgrade your plan to use this template." : i;
      default:
        return i;
    }
  } };
};
export {
  y as useExecuteTemplate
};
//# sourceMappingURL=useExecuteTemplate.es.js.map
